import { ACTION_TYPES } from "../reduxConsts";

export const setIsAutoLoadShapesActive = (isActive) => ({ type: ACTION_TYPES.AREAS.SET_IS_MAP_AUTOLOAD_ACTIVE, value: isActive })